import useHandleAppException, { AppExceptionResponse } from '../../../hooks/useHandleAppException';
import LangEnum from '../../../lang/LangEnum';
import snackbarStore from '../../../stores/Snackbar.store';
import { useTranslation } from '../../translation/TranslationContext';

export const useRachelErrorReporter = () => {
  const { handleErrorResponse } = useHandleAppException();
  const { translate } = useTranslation();

  const reportRachelError = (error: unknown, messageOverride?: LangEnum) => {
    if (messageOverride) {
      console.error(error);
      snackbarStore.handleMessage({
        type: 'warning',
        message: translate(messageOverride),
      });
      return;
    }

    try {
      const errorMessage = handleErrorResponse(error as AppExceptionResponse);
      snackbarStore.handleMessage({
        type: 'error',
        message: errorMessage || translate(LangEnum.RACHEL_ERROR_GENERIC),
      });
    } catch (reportingError) {
      console.error(reportingError);
      snackbarStore.handleMessage({
        type: 'error',
        message: translate(LangEnum.RACHEL_ERROR_GENERIC),
      });
    }
  };

  return { reportRachelError };
};
